<template>
  <!-- 备份 -->
  <div class="layout">
    <el-container>
      <el-aside
        class="aside"
        :style="{ width: !isCollapse ? '140px' : '65px' }"
      >
        <el-menu :collapse="isCollapse" :router="false">
          <div class="userBoxMenu">
            <el-tooltip
              v-if="isCollapse"
              popper-class="userToolTip"
              effect="dark"
              :content="userInfo.uName"
              placement="right"
            >
              <img class="userPic" src="../../assets/img/leftNav/logo.png" />
            </el-tooltip>
            <img
              v-if="!isCollapse"
              class="userPic"
              src="../../assets/img/leftNav/logo.png"
            />
            <div class="userName" v-if="!isCollapse">
              花生宠物({{ $public.getShopNameById(curShopInfo.shop_id) }}店)
              <!-- <el-dropdown @command="clickDropdown">
								<span style="color:white;cursor: pointer;font-size: 16px;">
									{{userInfo.uName}}<i class="el-icon-arrow-down el-icon--right"></i>
								</span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item :command="'password'">修改密码</el-dropdown-item>
									<el-dropdown-item :command="'clearCacheReload'">重新加载</el-dropdown-item>
									<el-dropdown-item :command="'quit'">退出</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown> -->
            </div>
          </div>
          <version v-if="!isCollapse"></version>
        </el-menu>
        <el-menu
          :collapse="isCollapse"
          :default-active="$route.matched[0].path"
          :router="false"
          text-color="#fff"
          active-text-color="#FFFFFF"
        >
          <!-- 门店业务、医疗管理、订单管理、会员管理、采购管理、仓库管理 权限管理、营销中心、产品中心、数据中心、消息中心 -->
          <el-menu-item
            index="/mendian"
            @click="selectMenu('收银', '/mendian')"
          >
            <img
              v-if="$route.matched[0].path == '/mendian'"
              src="../../assets/img/leftNav/mendian.png"
              style="width: 16px; height: 16px"
            />
            <img
              v-else
              src="../../assets/img/leftNav/mendian.png"
              style="width: 16px; height: 16px"
            />
            <span slot="title">门店业务</span>
          </el-menu-item>
          <el-menu-item index="/yiliao" @click="selectMenu('挂号', '/yiliao')">
            <img
              v-if="$route.matched[0].path == '/yiliao'"
              src="../../assets/img/leftNav/yiliao.png"
              style="width: 16px; height: 16px"
            />
            <img
              v-else
              src="../../assets/img/leftNav/yiliao.png"
              style="width: 16px; height: 16px"
            />
            <span slot="title">医疗管理</span>
          </el-menu-item>
          <!-- <el-menu-item index="/yiliaoxin" @click="selectMenu('医疗工作台','/yiliaoxin')">
						<img v-if="$route.matched[0].path=='/yiliaoxin'" src="../../assets/img/leftNav/yiliao.png" style="width:16px;height: 16px;"/>
						<img v-else src="../../assets/img/leftNav/yiliao.png" style="width:16px;height: 16px;"/>
						<span slot="title">新医疗管理</span>
					</el-menu-item> -->
          <el-menu-item
            index="/jiyang"
            @click="selectMenu('寄养管理', '/jiyang')"
          >
            <img
              v-if="$route.matched[0].path == '/jiyang'"
              src="../../assets/img/leftNav/jiyang.png"
              style="width: 16px; height: 16px"
            />
            <img
              v-else
              src="../../assets/img/leftNav/jiyang.png"
              style="width: 16px; height: 16px"
            />
            <span slot="title">寄养管理</span>
          </el-menu-item>
          <el-menu-item
            index="/dingdan"
            @click="selectMenu('订单', '/dingdan')"
          >
            <img
              v-if="$route.matched[0].path == '/dingdan'"
              src="../../assets/img/leftNav/dingdan.png"
              style="width: 16px; height: 16px"
            />
            <img
              v-else
              src="../../assets/img/leftNav/dingdan.png"
              style="width: 16px; height: 16px"
            />
            <span slot="title">订单管理</span>
          </el-menu-item>
          <el-menu-item
            index="/huiyuan"
            @click="selectMenu('会员列表', '/huiyuan')"
          >
            <img
              v-if="$route.matched[0].path == '/huiyuan'"
              src="../../assets/img/leftNav/huiyuan.png"
              style="width: 16px; height: 16px"
            />
            <img
              v-else
              src="../../assets/img/leftNav/huiyuan.png"
              style="width: 16px; height: 16px"
            />
            <span slot="title">会员管理</span>
          </el-menu-item>

          <el-submenu :index="'/caigou' || '/caigouMendian'">
            <template slot="title">
              <img
                v-if="$route.matched[0].path.split('-')[0] === '/caigou'"
                src="../../assets/img/leftNav/caigou.png"
                style="width: 16px; height: 16px"
              />
              <img
                v-else
                src="../../assets/img/leftNav/caigou.png"
                style="width: 16px; height: 16px"
              />
              <span slot="title">采购管理</span>
            </template>
            <el-menu-item
              index="/caigouMendian"
              @click="selectMenu('门店采购', '/caigouMendian/shopPurchase')"
            >
              <span slot="title">门店采购</span>
            </el-menu-item>
            <el-menu-item
              v-if="$public.checkAuth('采购')"
              index="/caigou"
              @click="selectMenu('审批', '/caigou')"
            >
              <span slot="title">总仓采购</span>
            </el-menu-item>
          </el-submenu>

          <el-submenu
            :index="'/huotiZongcang' || '/huotiMendian' || '/huotiPeizhi'"
          >
            <template slot="title">
              <img
                v-if="$route.matched[0].path.split('-')[0] === '/huotiZongcang'"
                src="../../assets/img/leftNav/huoti.png"
                style="width: 16px; height: 16px"
              />
              <img
                v-else
                src="../../assets/img/leftNav/huoti.png"
                style="width: 16px; height: 16px"
              />
              <span slot="title">活体管理</span>
            </template>
            <el-menu-item
              v-if="$public.checkAuth('活体主管')"
              index="/huotiZongcang"
              @click="selectMenu('指挥中心', '/huotiZongcang')"
            >
              <span slot="title">指挥中心</span>
            </el-menu-item>
            <el-menu-item
              v-else
              index="/huotiMendian"
              @click="selectMenu('门店管理', '/huotiMendian')"
            >
              <span slot="title">门店管理</span>
            </el-menu-item>
            <el-menu-item
              index="/huotiPeizhi"
              @click="selectMenu('任务设置', '/huotiPeizhi')"
            >
              <span slot="title">任务设置</span>
            </el-menu-item>
          </el-submenu>

          <!-- <el-menu-item index="/huoti" @click="selectMenu('活体管理','/huoti')">
						<img v-if="$route.matched[0].path=='/huoti'" src="../../assets/img/huoti.png" style="width:16px;height: 16px;"/>
						<img v-else src="../../assets/img/huoti1.png" style="width:16px;height: 16px;"/>
						<span slot="title">活体管理</span>
					</el-menu-item> -->

          <el-menu-item
            v-if="$public.checkAuth('管理员')"
            index="/huodong"
            @click="selectMenu('活动管理', '/huodong')"
          >
            <img
              v-if="$route.matched[0].path == '/huodong'"
              src="../../assets/img/leftNav/huodong.png"
              style="width: 16px; height: 16px"
            />
            <img
              v-else
              src="../../assets/img/leftNav/huodong.png"
              style="width: 16px; height: 16px"
            />
            <span slot="title">活动管理</span>
          </el-menu-item>

          <el-menu-item index="/kehu" @click="selectMenu('客户管理', '/kehu')">
            <img
              v-if="$route.matched[0].path == '/kehu'"
              src="../../assets/img/leftNav/huodong.png"
              style="width: 16px; height: 16px"
            />
            <img
              v-else
              src="../../assets/img/leftNav/huodong.png"
              style="width: 16px; height: 16px"
            />
            <span slot="title">客户管理</span>
          </el-menu-item>

          <el-menu-item
            index="/cangku"
            @click="selectMenu('库存信息', '/cangku')"
          >
            <img
              v-if="$route.matched[0].path == '/cangku'"
              src="../../assets/img/leftNav/cangku.png"
              style="width: 16px; height: 16px"
            />
            <img
              v-else
              src="../../assets/img/leftNav/cangku.png"
              style="width: 16px; height: 16px"
            />
            <span slot="title">仓库管理</span>
          </el-menu-item>
          <!-- <el-menu-item index="/quanxian" @click="selectMenu('权限','/quanxian')">
						<img v-if="$route.matched[0].path=='/quanxian'" src="../../assets/img/quanxian.png" style="width:16px;height: 16px;"/>
						<img v-else src="../../assets/img/quanxian1.png" style="width:16px;height: 16px;"/>
						权限管理
					</el-menu-item>
					<el-menu-item index="/yingxiao" @click="selectMenu('营销','/yingxiao')">
						<img v-if="$route.matched[0].path=='/yingxiao'" src="../../assets/img/yingxiao.png" style="width:16px;height: 16px;"/>
						<img v-else src="../../assets/img/yingxiao1.png" style="width:16px;height: 16px;"/>
						营销中心
					</el-menu-item>  -->
          <el-menu-item
            v-if="$public.checkAuth('管理员,产品运营')"
            index="/chanpin"
            @click="selectMenu('活体', '/chanpin')"
          >
            <img
              v-if="$route.matched[0].path == '/chanpin'"
              src="../../assets/img/leftNav/chanpin.png"
              style="width: 16px; height: 16px"
            />
            <img
              v-else
              src="../../assets/img/leftNav/chanpin.png"
              style="width: 16px; height: 16px"
            />
            <span slot="title">产品中心</span>
          </el-menu-item>
          <el-menu-item
            v-if="$public.checkAuth('管理员,店长')"
            index="/shuju"
            @click="selectMenu('门店数据', '/shuju')"
          >
            <img
              v-if="$route.matched[0].path == '/shuju'"
              src="../../assets/img/leftNav/shuju.png"
              style="width: 16px; height: 16px"
            />
            <img
              v-else
              src="../../assets/img/leftNav/shuju.png"
              style="width: 16px; height: 16px"
            />
            <span slot="title">数据中心</span>
          </el-menu-item>
          <el-menu-item
            v-if="$public.checkAuth('管理员')"
            index="/signature"
            @click="selectMenu('全部文件', '/signature')"
          >
            <img
              v-if="$route.matched[0].path == '/signature'"
              src="../../assets/img/leftNav/qianzhang.png"
              style="width: 16px; height: 16px"
            />
            <img
              v-else
              src="../../assets/img/leftNav/qianzhang.png"
              style="width: 16px; height: 16px"
            />
            <span slot="title">签章管理</span>
          </el-menu-item>
          <el-menu-item index="/msg" @click="selectMenu('我的消息', '/msg')">
            <img
              v-if="$route.matched[0].path == '/msg'"
              src="../../assets/img/leftNav/xiaoxi.png"
              style="width: 16px; height: 16px"
            />
            <img
              v-else
              src="../../assets/img/leftNav/xiaoxi.png"
              style="width: 16px; height: 16px"
            />
            <span slot="title">
              消息中心
              <span
                class="dot"
                v-if="
                  $public.checkAuth('管理员') &&
                  $public.jia(
                    msg_unread_num_obj.globalMsgSum.commonMsg,
                    msg_unread_num_obj.globalMsgSum.policyMsg,
                    msg_unread_num_obj.globalMsgSum.shopMsg
                  ) > 0
                "
              >
                <span>
                  {{
                    $public.jia(
                      msg_unread_num_obj.globalMsgSum.commonMsg,
                      msg_unread_num_obj.globalMsgSum.policyMsg,
                      msg_unread_num_obj.globalMsgSum.shopMsg
                    )
                  }}
                </span>
              </span>
              <span
                class="dot"
                v-if="
                  !$public.checkAuth('管理员') &&
                  $public.jia(
                    msg_unread_num_obj.myMsgSum.commonMsg,
                    msg_unread_num_obj.myMsgSum.policyMsg,
                    msg_unread_num_obj.myMsgSum.shopMsg
                  ) > 0
                "
              >
                <span>
                  {{
                    $public.jia(
                      msg_unread_num_obj.myMsgSum.commonMsg,
                      msg_unread_num_obj.myMsgSum.policyMsg,
                      msg_unread_num_obj.myMsgSum.shopMsg
                    )
                  }}
                </span>
              </span>
            </span>
          </el-menu-item>
          <el-menu-item
            index="/refund"
            @click="selectMenu('审批管理', '/refund')"
          >
            <img
              v-if="$route.matched[0].path == '/refund'"
              src="../../assets/img/leftNav/tuikuan.png"
              style="width: 16px; height: 16px"
            />
            <img
              v-else
              src="../../assets/img/leftNav/tuikuan.png"
              style="width: 16px; height: 16px"
            />
            <span slot="title">
              退款审批
              <!-- <span
							class="dot"
							v-if="$public.checkAuth('管理员')&&$public.jia(msg_unread_num_obj.globalMsgSum.commonMsg, msg_unread_num_obj.globalMsgSum.policyMsg, msg_unread_num_obj.globalMsgSum.shopMsg)>0"
							>
								<span>
									{{$public.jia(msg_unread_num_obj.globalMsgSum.commonMsg, msg_unread_num_obj.globalMsgSum.policyMsg, msg_unread_num_obj.globalMsgSum.shopMsg)}}
								</span>
							</span>
							<span
							class="dot"
							v-if="!$public.checkAuth('管理员')&&$public.jia(msg_unread_num_obj.myMsgSum.commonMsg, msg_unread_num_obj.myMsgSum.policyMsg, msg_unread_num_obj.myMsgSum.shopMsg)>0"
							>
								<span>
									{{$public.jia(msg_unread_num_obj.myMsgSum.commonMsg, msg_unread_num_obj.myMsgSum.policyMsg, msg_unread_num_obj.myMsgSum.shopMsg)}}
								</span>
							</span> -->
            </span>
          </el-menu-item>
          <el-submenu :index="'/pragram'" v-if="$public.checkAuth('管理员')">
            <template slot="title">
              <img
                v-if="$route.matched[0].path.split('-')[0] === '/program'"
                src="../../assets/img/leftNav/xiaochengxu.png"
                style="width: 16px; height: 16px"
              />
              <img
                v-else
                src="../../assets/img/leftNav/xiaochengxu.png"
                style="width: 16px; height: 16px"
              />
              <span slot="title">小程序管理</span>
            </template>
            <el-menu-item
              index="/program"
              @click="selectMenu('广告位', '/program/advertising')"
            >
              <span slot="title">广告位</span>
            </el-menu-item>
            <el-menu-item
              index="/petlooking"
              @click="selectMenu('宠物求购', '/petlooking/petlooking')"
            >
              <span slot="title">宠物求购</span>
            </el-menu-item>
            <el-menu-item
              index="/petshop"
              @click="selectMenu('宠物商城', '/petshop/petshop')"
            >
              <span slot="title">活体商城</span>
            </el-menu-item>
            <el-menu-item
              index="/petgift"
              @click="selectMenu('宠物礼包', '/petgift/petgiftbag')"
            >
              <span slot="title">宠物礼包</span>
            </el-menu-item>
            <el-menu-item
              index="/breedplan"
              @click="selectMenu('宠物礼包', '/breedplan/breedplan')"
            >
              <span slot="title">饲养计划</span>
            </el-menu-item>
            <el-menu-item
              index="/goodsShop"
              @click="selectMenu('商品商城', '/goodsShop/goodsShop')"
            >
              <span slot="title">商品商城</span>
            </el-menu-item>
            <el-menu-item
              index="/join"
              @click="selectMenu('多人拼团', '/join/join')"
            >
              <span slot="title">多人拼团</span>
            </el-menu-item>
            <el-menu-item
              index="/special"
              @click="selectMenu('限时特价', '/special/special')"
            >
              <span slot="title">限时特价</span>
            </el-menu-item>
          </el-submenu>
          <!-- <el-menu-item index="/shezhi" @click="selectMenu('设置','/shezhi')">
						<img v-if="$route.matched[0].path=='/shezhi'" src="../../assets/img/shezhi.png" style="width:16px;height: 16px;"/>
						<img v-else src="../../assets/img/shezhi1.png" style="width:16px;height: 16px;"/>
						<span slot="title">设置</span>
					</el-menu-item> -->

          <!-- <el-submenu index="/yuangong">
						<template slot="title">
							<img v-if="$route.matched[0].path=='/yuangong'" src="../../assets/img/yuangong.png" style="width:16px;height: 16px;"/>
							<img v-else src="../../assets/img/yuangong1.png" style="width:16px;height: 16px;"/>
							员工交接
						</template>
						<el-menu-item index="/yuangong/yuangong1">交班列表</el-menu-item>
						<el-menu-item index="/yuangong/yuangong2">当班单</el-menu-item>
						<el-menu-item index="/yuangong/yuangong3">交班</el-menu-item>
						<el-menu-item index="/yuangong/yuangong4">排班</el-menu-item>
					</el-submenu> -->
        </el-menu>
      </el-aside>
      <el-container
        class="container"
        :style="{ 'margin-left': !isCollapse ? '140px' : '65px' }"
      >
        <div
          class="headBox"
          :style="{ 'padding-left': !isCollapse ? '140px' : '65px' }"
        >
          <div style="display: inline-flex">
            <img
              v-if="!isCollapse"
              @click="isCollapse = !isCollapse"
              style="
                width: 20px;
                height: 20px;
                margin-top: 15px;
                margin-left: 4px;
                cursor: pointer;
              "
              src="../../assets/img/collapse.png"
            />
            <img
              v-if="isCollapse"
              @click="isCollapse = !isCollapse"
              style="
                width: 20px;
                height: 20px;
                margin-top: 15px;
                margin-left: 4px;
                cursor: pointer;
              "
              src="../../assets/img/collapse1.png"
            />
            <!-- <div v-if="$route.matched[0].path!='/chanpin' " class="headShopName">
							花生宠物
							<span
							v-for="(item,index) in shopList"
							:key="index"
							>
								<span v-if="curShopInfo.shop_id===item.shop_id">({{$public.getShopNameById(item.shop_id)}})</span>
							</span>
						</div> -->
            <!-- 门店 -->
            <div class="nav" v-if="$route.matched[0].path == '/mendian'">
              <tabNav
                :list="mendianNavList"
                :curItem="curNavIndex"
                @change="changeCurNavIndex"
              ></tabNav>
            </div>
            <!-- 医疗 -->
            <div class="nav" v-if="$route.matched[0].path == '/yiliao'">
              <tabNav
                :list="
                  yiliaoNavList.filter((item) => {
                    return (
                      item.name !== '药房' ||
                      (item.name === '药房' &&
                        ($public.checkAuth('医助') ||
                          $public.checkAuth('医生') ||
                          $public.checkAuth('店长')))
                    );
                  })
                "
                :curItem="curNavIndex"
                @change="changeCurNavIndex"
              ></tabNav>
            </div>
            <!-- 新医疗 -->
            <div class="nav" v-if="$route.matched[0].path == '/yiliaoxin'">
              <tabNav
                :list="yiliaoxinNavList"
                :curItem="curNavIndex"
                @change="changeCurNavIndex"
              ></tabNav>
            </div>
            <!-- <div class="nav" v-if="$route.matched[0].path=='/yiliao'">
							<div class="navItem"
							v-show="item.name!=='药房'||(item.name==='药房'&&(userInfo.role==='2'||userInfo.role==='3'||userInfo.role==='4'))"
							v-for="(item,index) in yiliaoNavList" :key="index"
							:class="curNavIndex.title==item.title?'active':''"
							@click="changeCurNavIndex(item)">
								{{item.name}}
							</div>
						</div> -->
            <!-- 订单 -->
            <div class="nav" v-if="$route.matched[0].path == '/dingdan'">
              <tabNav
                :list="dingdanNavList"
                :curItem="curNavIndex"
                @change="changeCurNavIndex"
              ></tabNav>
            </div>
            <!-- <div class="nav" v-if="$route.matched[0].path=='/dingdan'">
							<div class="navItem"
							v-for="(item,index) in dingdanNavList" :key="index"
							:class="curNavIndex.title==item.title?'active':''"
							@click="changeCurNavIndex(item)">
								{{item.name}}
							</div>
						</div> -->
            <!-- 会员 -->
            <div class="nav" v-if="$route.matched[0].path == '/huiyuan'">
              <div
                class="navItem"
                v-for="(item, index) in huiyuanNavList"
                :key="index"
                :class="curNavIndex.title == item.title ? 'active' : ''"
                @click="changeCurNavIndex(item)"
              >
                {{ item.name }}
              </div>
            </div>
            <!-- 采购-->
            <div class="nav" v-if="$route.matched[0].path == '/caigou'">
              <tabNav
                :list="caigouNavList"
                :curItem="curNavIndex"
                @change="changeCurNavIndex"
              ></tabNav>
            </div>
            <!-- 门店采购-->
            <!-- 	<div class="nav" v-if="$route.matched[0].path=='/caigouMendian'">
							<tabNav
							:list="caigouMendianList"
							:curItem="curNavIndex" @change="changeCurNavIndex"></tabNav>
						</div> -->

            <!-- 客户管理-->
            <div class="nav" v-if="$route.matched[0].path == '/kehu'">
              <tabNav
                v-if="this.$public.checkAuth('管理员')"
                :list="kehuNavList"
                :curItem="curNavIndex"
                @change="changeCurNavIndex"
              ></tabNav>
              <tabNav
                v-else-if="this.$public.checkAuth('店长')"
                :list="
                  kehuNavList.filter((item) => {
                    return item.name == '物料管理' || item.name == '员工管理';
                  })
                "
                :curItem="curNavIndex"
                @change="changeCurNavIndex"
              ></tabNav>
              <tabNav
                v-else-if="this.$public.checkAuth('采购')"
                :list="
                  kehuNavList.filter((item) => {
                    return item.name == '物料管理';
                  })
                "
                :curItem="curNavIndex"
                @change="changeCurNavIndex"
              ></tabNav>
              <tabNav
                v-else
                :list="
                  kehuNavList.filter((item) => {
                    return item.name == '工作台';
                  })
                "
                :curItem="curNavIndex"
                @change="changeCurNavIndex"
              ></tabNav>
            </div>
            <!-- <div class="nav" v-if="$route.matched[0].path=='/caigou'">
							<div class="navItem"
							v-for="(item,index) in caigouNavList" :key="index"
							:class="curNavIndex.title==item.title?'active':''"
							@click="changeCurNavIndex(item)">
								{{item.name}}
							</div>
						</div> -->
            <!-- 门店采购-->
            <!-- <div class="nav" v-if="$route.matched[0].path=='/caigou-mendian'">
							<div class="navItem"
							v-for="(item,index) in caigouMendianNavList" :key="index"
							:class="curNavIndex.title==item.title?'active':''"
							@click="changeCurNavIndex(item)">
								{{item.name}}
							</div>
						</div> -->
            <!-- 活体 -->
            <div class="nav" v-if="$route.matched[0].path == '/huoti'">
              <tabNav
                :curItem="curNavIndex"
                @change="changeCurNavIndex"
              ></tabNav>
            </div>
            <!-- 仓库 -->
            <div class="nav" v-if="$route.matched[0].path == '/cangku'">
              <tabNav
                :list="cangkuNavList"
                :curItem="curNavIndex"
                @change="changeCurNavIndex"
              ></tabNav>
            </div>
            <!-- 权限 -->
            <div class="nav" v-if="$route.matched[0].path == '/quanxian'">
              <div
                class="navItem"
                v-for="(item, index) in quanxianNavList"
                :key="index"
                :class="curNavIndex.title == item.title ? 'active' : ''"
                @click="changeCurNavIndex(item)"
              >
                {{ item.name }}
              </div>
            </div>
            <!-- 营销 -->
            <div class="nav" v-if="$route.matched[0].path == '/yingxiao'">
              <div
                class="navItem"
                v-for="(item, index) in yingxiaoNavList"
                :key="index"
                :class="curNavIndex.title == item.title ? 'active' : ''"
                @click="changeCurNavIndex(item)"
              >
                {{ item.name }}
              </div>
            </div>
            <!-- 产品 -->
            <div class="nav" v-if="$route.matched[0].path == '/chanpin'">
              <tabNav
                :list="chanpinNavList"
                :curItem="curNavIndex"
                @change="changeCurNavIndex"
              ></tabNav>
            </div>
            <!-- <div class="nav" v-if="$route.matched[0].path=='/chanpin'">
							<div class="navItem"
							v-for="(item,index) in chanpinNavList" :key="index"
							:class="curNavIndex.title==item.title?'active':''"
							@click="changeCurNavIndex(item)">
								{{item.name}}
							</div>
						</div> -->
            <!-- 数据 -->
            <div class="nav" v-if="$route.matched[0].path == '/shuju'">
              <tabNav
                v-if="this.$public.checkAuth('管理员')"
                :list="shujuNavList"
                :curItem="curNavIndex"
                @change="changeCurNavIndex"
              ></tabNav>
              <tabNav
                v-else-if="this.$public.checkAuth('店长')"
                :list="
                  shujuNavList.filter((item) => {
                    return (
                      item.name == '业绩pk' ||
                      item.name == '门店数据' ||
                      item.name == '员工提成'
                    );
                  })
                "
                :curItem="curNavIndex"
                @change="changeCurNavIndex"
              ></tabNav>
              <tabNav
                v-else
                :list="
                  shujuNavList.filter((item) => {
                    return item.name == 'abcd';
                  })
                "
                :curItem="curNavIndex"
                @change="changeCurNavIndex"
              ></tabNav>
            </div>
            <!-- <div class="nav" v-if="$route.matched[0].path=='/shuju'">
							<div class="navItem"
							v-for="(item,index) in !this.$public.checkAuth('管理员,店长')?shujuNavList.filter(item=>{
								return item.name=='员工提成'
							}):shujuNavList" :key="index"
							:class="curNavIndex.title==item.title?'active':''"
							@click="changeCurNavIndex(item)">
								{{item.name}}
							</div>
						</div> -->
            <!-- 签章 -->
            <div class="nav" v-if="$route.matched[0].path == '/signature'">
              <tabNav
                :list="signatureNavList"
                :curItem="curNavIndex"
                @change="changeCurNavIndex"
              ></tabNav>
            </div>
            <!-- 消息中心 -->
            <div class="nav" v-if="$route.matched[0].path == '/msg'">
              <div v-if="this.$public.checkAuth('管理员')">
                <tabNav
                  :list="msgNavList"
                  :curItem="curNavIndex"
                  @change="changeCurNavIndex"
                >
                </tabNav>
              </div>
              <div v-else-if="this.$public.checkAuth('店长')">
                <tabNav
                  :list="
                    msgNavList.filter((item) => {
                      return item.name !== '全站消息';
                    })
                  "
                  :curItem="curNavIndex"
                  @change="changeCurNavIndex"
                >
                </tabNav>
              </div>
              <div v-else>
                <tabNav
                  :list="
                    msgNavList.filter((item) => {
                      return (
                        item.name == '我的消息' ||
                        item.name == '已删除' ||
                        item.name == '我的收藏'
                      );
                    })
                  "
                  :curItem="curNavIndex"
                  @change="changeCurNavIndex"
                >
                </tabNav>
              </div>
            </div>
            <!-- 退款审批 -->
            <div class="nav" v-if="$route.matched[0].path == '/refund'">
              <div>
                <tabNav
                  :list="refundNavList"
                  :curItem="curNavIndex"
                  @change="changeCurNavIndex"
                >
                </tabNav>
              </div>
            </div>
            <!-- 设置 -->
            <div class="nav" v-if="$route.matched[0].path == '/shezhi'">
              <div
                class="navItem"
                v-for="(item, index) in shezhiNavList"
                :key="index"
                :class="curNavIndex.title == item.title ? 'active' : ''"
                @click="changeCurNavIndex(item)"
              >
                {{ item.name }}
              </div>
            </div>
            <!--小程序管理-->
            <div class="nav" v-if="$route.matched[0].path == '/program'">
              <div
                class="navItem"
                v-for="(item, index) in program"
                :key="index"
                :class="curNavIndex.title == item.title ? 'active' : ''"
                @click="changeCurNavIndex(item)"
              >
                {{ item.name }}
              </div>
            </div>
            <div class="nav" v-if="$route.matched[0].path == '/join'">
              <tabNav
                :list="joinNavList"
                :curItem="curNavIndex"
                @change="changeCurNavIndex"
              ></tabNav>
            </div>
          </div>
          <div class="userBox">
            <div
              style="
                position: relative;
                padding-top: 10px;
                padding-right: 15px;
                box-sizing: border-box;
                cursor: pointer;
              "
              @click="selectMenu('我的消息', '/msg')"
            >
              <img
                src="../../assets/img/lingdang.png"
                style="width: 28px; height: 28px"
              />
              <span
                style="
                  position: absolute;
                  right: 7px;
                  height: 15px;
                  line-height: 17px;
                "
                class="dot"
                v-if="
                  $public.checkAuth('管理员') &&
                  $public.jia(
                    msg_unread_num_obj.globalMsgSum.commonMsg,
                    msg_unread_num_obj.globalMsgSum.policyMsg,
                    msg_unread_num_obj.globalMsgSum.shopMsg
                  ) > 0
                "
              >
                <span>
                  {{
                    $public.jia(
                      msg_unread_num_obj.globalMsgSum.commonMsg,
                      msg_unread_num_obj.globalMsgSum.policyMsg,
                      msg_unread_num_obj.globalMsgSum.shopMsg
                    )
                  }}
                </span>
              </span>
              <span
                style="
                  position: absolute;
                  right: 7px;
                  height: 15px;
                  line-height: 17px;
                "
                class="dot"
                v-if="
                  !$public.checkAuth('管理员') &&
                  $public.jia(
                    msg_unread_num_obj.myMsgSum.commonMsg,
                    msg_unread_num_obj.myMsgSum.policyMsg,
                    msg_unread_num_obj.myMsgSum.shopMsg
                  ) > 0
                "
              >
                <span>
                  {{
                    $public.jia(
                      msg_unread_num_obj.myMsgSum.commonMsg,
                      msg_unread_num_obj.myMsgSum.policyMsg,
                      msg_unread_num_obj.myMsgSum.shopMsg
                    )
                  }}
                </span>
              </span>
            </div>
            <div
              style="
                padding-top: 8px;
                padding-right: 15px;
                box-sizing: border-box;
                cursor: pointer;
              "
              @click="selectMenu('帮助中心', '/jiaocheng')"
            >
              <img
                src="../../assets/img/jiaocheng.png"
                style="width: 32px; height: 32px"
              />
            </div>
            <img class="userPic" src="../../assets/img/headPic.jpg" />
            <div class="userName">
              <el-dropdown @command="clickDropdown">
                <span style="cursor: pointer">
                  {{ userInfo.uName
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="'password'"
                    >修改密码</el-dropdown-item
                  >
                  <el-dropdown-item :command="'clearCacheReload'"
                    >重新加载</el-dropdown-item
                  >
                  <el-dropdown-item :command="'quit'">退出</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </div>
        <el-main :style="{ height: mainHeight + 'px' }">
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive"></router-view>
        </el-main>
      </el-container>
    </el-container>
   
    <iframe
      v-if="printUrl"
      :src="'HSPrint:' + printUrl"
      width="0"
      height="0"
    ></iframe>
  </div>
</template>

<script>
import version from "../../components/version.vue";
import tabNav from "../../components/tabNav.vue";
export default {
  components: { version, tabNav },
  data() {
    return {
      ws: null,

      mainHeight: 0,

      isCollapse: false,
      // 门店
      mendianNavList: [
        { title: "工作台", name: "工作台", path: "/mendian/shouyin" },
        // {title:'洗澡',name:'洗澡',path:'/mendian/xizao'},
        // {title:'美容',name:'美容',path:'/mendian/meirong'},
        // {title:'寄养',name:'寄养',path:'/mendian/jiyang'},
        // {title:'换购',name:'换购',path:'/mendian/huangou'},
        { title: "新增顾客", name: "新增顾客", path: "/mendian/addUser" },
        // {title:'新增会员',name:'新增会员',path:'/mendian/huiyuanAdd'},
        // {title:'挂号',name:'挂号',path:'/mendian/guahaoAdd'},
        { title: "预约列表", name: "预约列表", path: "/mendian/yuyue", num: 0 },
        // {title:'提醒',name:'提醒',path:'/mendian/tixing'},
        // {title:'充值',name:'充值',path:'/mendian/chongzhi'},
        // {title:'查询条码信息',name:'查询条码信息',path:'/mendian/scanCodeSee'},
      ],
      // 医疗
      yiliaoNavList: [
        { title: "挂号", name: "挂号", path: "/yiliao/guahaoAdd" },
        { title: "接诊", name: "接诊", path: "/yiliao/guahaoList" },
        { title: "疫苗驱虫", name: "疫苗驱虫", path: "/yiliao/ymqcList" },
        { title: "服务套餐", name: "医疗服务", path: "/yiliao/ylfwList" },
        { title: "住院", name: "住院", path: "/yiliao/zhuyuanList" },
        { title: "病例", name: "病例", path: "/yiliao/bingliList" },
        { title: "药房", name: "药房", path: "/yiliao/pharmacyList" },
      ],
      // 新医疗
      yiliaoxinNavList: [
        {
          title: "医疗工作台",
          name: "医疗工作台",
          path: "/yiliaoxin/platform",
        },
        { title: "医疗标签", name: "医疗标签", path: "/yiliaoxin/tagList" },
      ],
      // 订单
      dingdanNavList: [
        { title: "消费订单", name: "消费订单", path: "/dingdan/saleOrderList" },
        {
          title: "充值订单",
          name: "充值订单",
          path: "/dingdan/rechargeOrderList",
        },
        {
          title: "退换货订单",
          name: "退换货订单",
          path: "/dingdan/returnOrderList",
        },
      ],
      // 会员
      huiyuanNavList: [
        // {title:'基本信息',name:'挂号',path:'/yiliao/guahaoAdd'},
        // {title:'消费卡记录',name:'接诊',path:'/yiliao/guahaoList'},
        // {title:'押金信息',name:'疫苗驱虫',path:'/yiliao/ymqcList'},
        // {title:'宠物资料',name:'医疗服务',path:'/yiliao/ylfwList'},
        // {title:'消费记录',name:'住院',path:'/yiliao/zhuyuanList'},
        // {title:'充值记录',name:'病例',path:'/yiliao/bingliList'},
        // {title:'退换货记录',name:'药房',path:'/yiliao/pharmacyList'},
      ],
      // 采购
      caigouNavList: [
        { title: "商品审批", name: "商品审批", path: "/caigou/shenpiList" },
        { title: "商品采购", name: "商品采购", path: "/caigou/caigouList" },
        { title: "条码追踪", name: "条码追踪", path: "/caigou/tiaoma" },
        { title: "新品列表", name: "新品列表", path: "/caigou/xinpinList" },
        { title: "预警提醒", name: "预警提醒", path: "/caigou/yujingList" },
        // {title:'物料审批',name:'物料审批',path:'/caigou/wuliaoShenpiList'},
        // {title:'物料采购',name:'物料采购',path:'/caigou/wuliaoCaigouList'}
      ],
      // 客户管理
      kehuNavList: [
        { title: "工作台", name: "工作台", path: "/kehu/index" },
        // {title:'数据列表',name:'数据列表',path:'/kehu/shujuList'},
        { title: "员工管理", name: "员工管理", path: "/kehu/yuangongList" },
        // {title:'物料管理',name:'物料管理',path:'/kehu/wuliaoList'}
      ],
      // 门店采购
      caigouMendianList: [
        {
          title: "商品采购",
          name: "商品采购",
          path: "/caigouMendian/shopPurchase",
        },
        // {title:'物料采购',name:'物料采购',path:'/caigouMendian/wuliaoList'}
      ],
      // 仓库
      cangkuNavList: [
        // {title:'商品信息',name:'商品信息',path:'/cangku/goodslist'},
        { title: "库存信息", name: "库存信息", path: "/cangku/kucunList" },
        // {title:'服务',name:'服务',path:'/cangku/serviceList'},
        {
          title: "过期预警",
          name: "过期预警",
          path: "/cangku/guoqiWarningList",
        },
        {
          title: "库存预警",
          name: "库存预警",
          path: "/cangku/kucunWarningList",
        },
        // {title:'商品套餐',name:'商品套餐',path:'/cangku/goodsGroupList'},
        { title: "入库查询", name: "入库查询", path: "/cangku/rukuList" },
        { title: "出库查询", name: "出库查询", path: "/cangku/chukuList" },
      ],
      // 权限
      quanxianNavList: [
        { title: "挂号", name: "挂号", path: "/quanxian/guahaoAdd" },
      ],
      // 营销
      yingxiaoNavList: [
        { title: "挂号", name: "挂号", path: "/yingxiao/guahaoAdd" },
      ],
      // 产品
      chanpinNavList: [
        {
          title: "商品",
          name: "商品",
          path: "/chanpin/goods",
        },
        {
          title: "药品",
          name: "药品",
          path: "/chanpin/medical",
        },
        {
          title: "套餐",
          name: "套餐",
          path: "/chanpin/group",
        },
        {
          title: "生活服务",
          name: "生活服务",
          path: "/chanpin/lifeservice",
        },
        {
          title: "医疗服务",
          name: "医疗服务",
          path: "/chanpin/medicalservice",
        },
        {
          title: "活体",
          name: "活体",
          path: "/chanpin/livingbody",
        },
        {
          title: "虚拟道具",
          name: "虚拟道具",
          path: "/chanpin/fictitious",
        },
        {
          title: "耗材",
          name: "耗材",
          path: "/chanpin/consumables",
        },
      ],
      // 数据
      shujuNavList: [
        // {title:'门店数据1',name:'门店数据1',path:'/shuju/shuju'},
        { title: "门店数据", name: "门店数据", path: "/shuju/mendianshuju" },
        { title: "业绩pk", name: "业绩pk", path: "/shuju/moneypk" },
        { title: "员工提成", name: "员工提成", path: "/shuju/staffshuju" },
        // {title:'活动统计',name:'活动统计',path:'/shuju/activity'},
        { title: "产品数据", name: "产品数据", path: "/shuju/productList" },
        { title: "活体数据", name: "活体数据", path: "/shuju/huoti" },
        { title: "活体数据", name: "优惠券统计", path: "/shuju/coupon" },
      ],
      // 签章管理
      signatureNavList: [
        { title: "全部文件", name: "全部文件", path: "/signature/fileList" },
        {
          title: "文件模板",
          name: "文件模板",
          path: "/signature/templateList",
        },
        {
          title: "文件统计",
          name: "文件统计",
          path: "/signature/fileStatistics",
        },
        {
          title: "印章管理",
          name: "印章管理",
          path: "/signature/signatureList",
        },
      ],
      // 消息中心
      msgNavList: [
        { title: "全站消息", name: "全站消息", path: "/msg/fileList", num: 0 },
        { title: "我的消息", name: "我的消息", path: "/msg/myMsgList", num: 0 },
        { title: "草稿箱", name: "草稿箱", path: "/msg/draftsList" },
        { title: "已发送", name: "已发送", path: "/msg/sentList" },
        { title: "已删除", name: "已删除", path: "/msg/deletedList" },
        { title: "我的收藏", name: "我的收藏", path: "/msg/collectionList" },
      ],
      // 退款审批
      refundNavList: [
        {
          title: "审批管理",
          name: "审批管理",
          path: "/refund/approveList",
          num: 0,
        },
        {
          title: "审批流程",
          name: "审批流程",
          path: "/refund/setList",
          num: 0,
        },
      ],
      // 设置
      shezhiNavList: [
        { title: "挂号", name: "挂号", path: "/shezhi/guahaoAdd" },
      ],
      //小程序管理
      program: [],
      //多人拼团
      joinNavList: [
        { title: "活动列表", name: "活动列表", path: "/join/join" },
        { title: "拼团列表", name: "拼团列表", path: "/join/list" },
      ],
      // 新增的活体详情
      dialogHuotiMsgDetail_state: false,
      huotiId: "",
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    curShopInfo() {
      return this.$store.getters.curShopInfo;
    },
    printUrl() {
      return this.$store.state.printUrl;
    },
    curNavIndex() {
      return this.$store.state[
        "curNavIndex_" + this.$route.matched[0].path.substr(1)
      ];
    },
    msg_online() {
      return this.$store.state.msg_online;
    },
    shopList() {
      return this.$store.getters.shopList;
    },
    msg_unread_num_obj() {
      this.$nextTick(() => {
        this.msgNavList[0].num = this.$public.jia(
          this.msg_unread_num_obj.globalMsgSum.commonMsg,
          this.msg_unread_num_obj.globalMsgSum.policyMsg,
          this.msg_unread_num_obj.globalMsgSum.shopMsg
        );
        this.msgNavList[1].num = this.$public.jia(
          this.msg_unread_num_obj.myMsgSum.commonMsg,
          this.msg_unread_num_obj.myMsgSum.policyMsg,
          this.msg_unread_num_obj.myMsgSum.shopMsg
        );
      });
      return this.$store.state.msg_unread_num_obj;
    },
  },
  watch: {
    printUrl(n) {
      if (n != "") {
        setTimeout(() => {
          this.$store.commit("set_printUrl", "");
        }, 1000);
      }
    },
  },
  created() {
    this.mainHeight = window.innerHeight - 60;
    window.openMessageDetail = this.openMessageDetail;
  },
  mounted() {
    if (!this.curNavIndex.path) {
      this.$store.commit("setCurNavIndex_mendian", {
        title: "工作台",
        path: "/mendian/shouyin",
      });
    }
  },
  methods: {
  
    // changeIsCollapse(){
    // 	this.isCollapse=!this.isCollapse;
    // 	if(this.isCollapse===true){
    // 		this.$store.commit('mendian/set_isCollapse','1')
    // 	}else{
    // 		this.$store.commit('mendian/set_isCollapse','0')
    // 	}
    // },
    changeYuyue() {
      for (let i = 0; i < this.mendianNavList.length; i++) {
        if (this.mendianNavList[i].title === "预约") {
          this.mendianNavList[i].num = this.msg_online.reservationList.length;
        }
      }
    },
    selectMenu(str, index) {
      if (index == "/shuju" && !this.$public.checkAuth("管理员,店长")) {
        str = "员工提成";
        index = "/shuju/staffshuju";
        this.$store.commit("setCurNavIndex_" + index.split("/")[1], {
          title: str,
          path: index,
        });
        this.$router.push({ path: index });
      } else if (
        this.$store.state["curNavIndex_" + index.split("/")[1]].title
      ) {
        console.log(
          this.$store.state["curNavIndex_" + index.split("/")[1]].path,
          111,
          this.$route.path.split("/")[1] !== index.split("/")[1],
          index.split("/")[1],
          this.$route.path.split("/")[1]
        );
        if (this.$route.path.split("/")[1] !== index.split("/")[1]) {
          console.log(
            this.$store.state["curNavIndex_" + index.split("/")[1]].path,
            333
          );
          this.$router.push({
            path: this.$store.state["curNavIndex_" + index.split("/")[1]].path,
          });
        }
      } else {
        console.log(index, 22);
        this.$store.commit("setCurNavIndex_" + index.split("/")[1], {
          title: str,
          path: index,
        });
        this.$router.push({ path: index });
      }
    },
    changeCurNavIndex(item) {
      if (this.curNavIndex.title !== item.title) {
        this.$store.commit("setCurNavIndex_" + item.path.split("/")[1], {
          title: item.title,
          path: item.path,
        });
        this.$router.push({ path: item.path });

        // 预约
        if (item.title === "预约") {
          this.msg_online.reservationList = [];
          this.$store.commit("set_msg_online", this.msg_online);
          this.changeYuyue();
        }
      }
    },
    clickDropdown(str) {
      if (str == "password") {
        this.$router.push({ path: "/changePwd/changePwd" });
      } else if (str == "clearCacheReload") {
        window.location.reload();
      } else if (str == "quit") {
        this.$confirm("确定退出?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          sessionStorage.clear();
          window.location.href =
            window.location.protocol + "//" + window.location.host;
        });
      }
    },
 
  },
  beforeDestroy() {
    this.ws.close();
    this.ws = null;
  },
};
</script>

<style lang="scss" scoped>
.layout {
  min-width: 1900px;
  height: 100%;
  // min-width: 1400px;height: 100%;
  .aside {
    background-color: #232323;
    position: fixed;
    height: 100%;
    z-index: 10;
    transition: 0.3s width ease-in-out;
    overflow-x: hidden;
  }
  .container {
    position: relative;
    padding-top: 60px;
    background-color: #f5f5f5;
    width: 100%;
    box-sizing: border-box;
    transition: 0.3s margin-left ease-in-out;
  }
  ::v-deep.el-menu {
    border-right: 0;
    width: 140px;
    background-color: #232323;
    .el-submenu {
      background-color: #232323;
      &:hover {
        background-color: #232323;
      }
      .el-submenu__title {
        i {
          color: #ffffff;
        }
        &:hover {
          background-color: $mainColor;
        }
      }
    }
    &.el-menu--collapse {
      width: 65px;
    }
    .userBoxMenu {
      text-align: center;
      padding: 12px 0 8px;
      background-color: #232323;
      .userPic {
        width: 56px;
        height: 56px;
        border-radius: 50%;
        margin-bottom: 7px;
        cursor: pointer;
      }
      .userName {
        display: block;
        overflow: hidden;
        white-space: nowrap;
        font-size: 14px;
        color: #fff;
      }
    }
    .el-menu-item {
      background-color: #232323;
      &:hover {
        background-color: $mainColor;
      }
      &.is-active {
        background-color: $mainColor;
      }
      &.is-disabled {
        opacity: 0.96;
        background-color: #232323 !important;
      }
    }
  }

  .headBox {
    position: fixed;
    display: flex;
    justify-content: space-between;
    left: 0;
    top: 0;
    width: 100%;
    box-sizing: border-box;
    z-index: 1;
    background-color: #ffffff;
    height: 48px;
    transition: 0.3s padding-left ease-in-out;
    padding-right: 15px;
    .headShopName {
      line-height: 48px;
      font-size: 20px;
      color: #2c2c2c;
      padding: 0 40px;
      font-weight: bold;
    }
    .nav {
      display: inline-flex;
      .navItem {
        font-size: 16px;
        color: #5c5c5c;
        padding: 27px 0 10px;
        margin: 0 30px;
        border-bottom: 2px solid transparent;
        cursor: pointer;
        &.active {
          font-weight: bold;
          color: $mainColor;
          border-color: $mainColor;
        }
      }
    }
    .userBox {
      display: inline-flex;
      .userPic {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        margin-top: 8px;
        margin-right: 5px;
      }
      .userName {
        display: block;
        overflow: hidden;
        white-space: nowrap;
        ::v-deep .el-dropdown {
          font-size: 14px;
          color: #333;
          margin-top: 17px;
        }
      }
    }
  }
  .el-main {
    color: #333;
    padding: 0px 10px 0 10px;
  }
}
</style>
<style lang="scss">
.el-tooltip__popper.userToolTip {
  margin-left: 20px;
}
.el-menu {
  background-color: #232323;
  .el-menu-item {
    background-color: #232323;
    &:hover {
      background-color: $mainColor;
    }
    &.is-active {
      background-color: $mainColor;
    }
  }
}
.dot {
  display: inline-block;
  background-color: #f56c6c;
  border-radius: 10px;
  height: 20px;
  min-width: 12px;
  line-height: 20px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  padding: 0 4px;
}
</style>
